import { isDestinationTemplateName, isProductTemplateName } from '@/cms/constants/template-names'
import { AllCMSPageFields } from '@/cms/fields/mappers/common'
import { Configuration } from '@/scopes/common/domain/types/configuration'
import { MetaDescriptionResolver } from '@/scopes/common/domain/types/meta-data'
import { IntlShape } from 'react-intl'
import { createCmsDestinationMetaDescriptionResolver } from './destination/cmsDestinationMetaDescriptionResolver'
import { createCmsProductMetaDescriptionResolver } from './product/cmsProductMetaDescriptionResolver'

interface MetaDescriptionResolverDependencies {
  config: Configuration
  cmsFields: AllCMSPageFields
  intl: IntlShape
}

export function createCmsMetaDescriptionResolver({
  config,
  cmsFields,
  intl,
}: MetaDescriptionResolverDependencies): MetaDescriptionResolver {
  if (isDestinationTemplateName(cmsFields.template)) {
    return createCmsDestinationMetaDescriptionResolver({ config, cmsFields, intl })
  }

  if (isProductTemplateName(cmsFields.template)) {
    return createCmsProductMetaDescriptionResolver({ config, cmsFields, intl })
  }

  return {
    resolve: () => undefined,
  }
}
